<template>
	<div ref="SettingCreate" class="dialog-container">
		<div class="dialog scroll" style="transform: translate(0, -400px); max-width: 680px;">
			<form @submit.stop="doValidation()">
				<div class="center dialog-flex" style="margin: 0;">
					<div>
						<div style="display: flex; justify-content: space-between; align-items: center;">
							<span class="dialog-tag">알림 등록</span>
							<div class="search-btn" style="width:120px;" @click.stop="openSearch()">
								<img src="@/assets/images/home/search.png"/>
								참여자 검색
							</div>
						</div>
						<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
							<colgroup>
								<col width="140px" />
								<col width="auto" />
							</colgroup>
							<tbody>
								<tr style="border-top: 1px solid #191C26">
									<th>참여자 번호</th>
									<td>
										<input class="input-crud" type="text" v-validate="'required'" disabled v-model="item.id"/>
									</td>
								</tr>
								<tr>
									<th>참여자 이름</th>
									<td>
										<input class="input-crud" type="text" disabled v-model="item.name"/>
									</td>
								</tr>
								<tr>
									<th>담당자</th>
									<td>
										<input class="input-crud" type="text" v-validate="'required'" disabled :value="item.userName"/>
									</td>
								</tr>
								<tr>
									<th>데이터 분류</th>
									<td>
										<select class="list-select" style="width: 100%;" v-model="item.recordType">
											<option value="">선택</option>
											<template
												v-for="(data, index) in recordTypeList"
											>
												<option :key="index + data.id" :value="data.recordType">{{ getRecordType(data.recordType)}}</option>
											</template>
											<!-- <option value="데이터분류">데이터분류</option>
											<option value="상태">상태</option> -->
										</select>
									</td>
								</tr>
								<tr>
									<th>상태</th>
									<td>
										<select class="list-select" style="width: 100%;" v-model="item.status">
											<option value="">선택</option>
											<option value="CAUTION">주의</option>
											<option value="EMERGENCY">경고</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>반복 횟수</th>
									<td>
										<input class="input-crud" type="number" v-model="item.repeatCnt"/>
									</td>
								</tr>
								<tr>
									<th>알림 메시지</th>
									<td>
										<textarea class="textarea-crud" v-model="item.alarmContents" required></textarea>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px;">
					<button type="button" class="btn-save" style="margin: 0;" title="Save" @click.stop="doValidation()">
						저장
					</button>
					<button type="button" class="btn-cancel" style="margin: 0;" title="Cancel" @click="doCancel()">
						닫기
					</button>
				</div>
			</form>
		</div>
		<CreateSearch v-if="isOpenSearch"/>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";
import CreateSearch from "@/components/setting/CreateSearch.vue";

export default {
	name: "SettingCreate",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
	},
	data() {
		return {
			userId: sessionStorage.getItem('userId'),
			userName: sessionStorage.getItem('userName'),
			item: {
				id: "",
				name: "",
				userId: sessionStorage.getItem('userId'),
				userName: sessionStorage.getItem('userName'),
				recordType : "",
				status: "",
				alarmContents: "",
				repeatCnt: 0
			},
			isTab: 1,
			isOpenSearch: false,
			recordTypeList: [],
		};
	},
	components: {
		CreateSearch,
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("등록 하시겠습니까?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		openSearch(){
			this.logger.debug(this, "openSearch()");
			this.isOpenSearch = true;
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/alarm/insertAlarm.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							// this.$parent.selectProjectList();
							// this.$parent.selectQuestionGroupList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.SettingCreate.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.SettingCreate.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isCreatePopup");
			}.bind(this), 410);
		},
		changeTap(type){
			this.isTab = type;
		},
		getRecordType(recordType){
			var result = "";

			if(recordType == 'WEIGHT'){
				result = '체중'
			}
			if(recordType == 'BLOOD_PRESSURE'){
				result = '혈압'
			}
			if(recordType == 'BLOOD_GLUCOSE'){
				result = '혈당'
			}
			if(recordType == 'HEART_RATE'){
				result = '심박수'
			}
			if(recordType == 'STEP_COUNT'){
				result = '걸음수'
			}
			if(recordType == 'CALORIE'){
				result = '칼로리'
			}
			if(recordType == 'PROTEINURIA'){
				result = '단백뇨'
			}
			if(recordType == 'OXYGEN_SATURATION'){
				result = '산소포화도'
			}
			if(recordType == 'STRESS'){
				result = '스트레스'
			}
			if(recordType == 'SLEEP_TIME'){
				result = '수면시간'
			}

			return result;
		},
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.participant-tab-zone{
	width: 100%;
	height: 48px;
	margin-top: 20px;
	background-color: #EBF4FF;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.participant-btn{
	height: 40px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 18px;
	cursor: pointer;
}
.participant-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.participant-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.font-red{
	color: #F94848;
}
.font-yellow{
	color: #FFAD09;
}
</style>